export { Placement } from '@ng-bootstrap/ng-bootstrap/util/positioning';
export * from './tooltip.directive';
export * from './tooltip.module';
export * from './tooltip.service';
